module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-button"
  }, [_c('button', {
    staticClass: "button open danger",
    on: {
      "click": _vm.onClick
    }
  }, [_c('p', {
    staticClass: "open__text"
  }, [_vm._t("default"), _vm._v("\n      " + _vm._s((_vm.buttonText + " (" + _vm.uploadsCount + ")")) + "\n      "), (_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-caret-up open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down open__icon ml-20",
    attrs: {
      "aria-hidden": "true"
    }
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29ef2abe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadManager/UnfinishedUploadsButton.vue
// module id = 852
// module chunks = 0